// Generic `useSyncExternalStore` binding for the framework-independent
// `Store`/`ReadableStore` type shared by the call engine and this job's own
// api/liveEvents store (docs/06 §3: "React only renders its published state").

import { useSyncExternalStore } from 'react';
import type { ReadableStore } from '@merkury/brain/call/store.js';

export function useStore<T>(store: ReadableStore<T>): T {
  return useSyncExternalStore(
    (listener) => store.subscribe(listener),
    () => store.get(),
    () => store.get(),
  );
}
